import { begriffBezeichnung, globalsAic } from "@/local";
import { EditControlProps, valueChanged } from "./EditComponentStatic";
import { Globals } from "../Globals";
import { toNumber } from "@/DataHelper";
export declare interface NumberControlProps extends EditControlProps {
  min?: number;
  max?: number;
  number?: number;
  format?: string;
  customClass?: string;
}

export async function mountedEditZahl(config: NumberControlConfig, props: NumberControlProps, uiData: NumberControlUIData) {
  const value = config.initValue;
  if (value && typeof value === "object") {
    uiData.number = value.value;
    if (value.faktor > 0) {
      uiData.number = value.value / value.faktor;
    }
  } else {
    uiData.number = config.initValue;
  }
  // darf ich nicht machen - weil sonst gilt es als "geändert" und Speichern wird aktiv!
  // if (number === null) {
  //   number = description;
  // }

  let format = props.format;
  let decimals = 2;
  let step = 0.01;
  if (config.column && config.column.meta) {
    if (config.column.meta.format) {
      format = config.column.meta.format;
    }
    if (format === "#") {
      config.ohneNachkomma = true;
      // decimals = 2;
      // format = "n0";
      format = "n2"; // ohne Dezimal gehts nicht
      decimals = 0;
      step = 1;
    } else if (format === "00.00" || format === "0.00") {
      decimals = 2;
      format = "n2";
      if (uiData.number) {
        let numberValue: any = toNumber(uiData.number);
        uiData.number = Number(numberValue.toFixed(2));

      }
    } else if (format === "00.0000") {
      decimals = 4;
      format = "n4";
      if (uiData.number) {
        let numberValue: any = toNumber(uiData.number);
        uiData.number = Number(numberValue.toFixed(4));
      }
    }
    if (
      config.column.meta.einheit &&
      !config.column.meta.originalEinheit
    ) {
      const einheit = config.column?.meta.einheit;
      if (einheit) {
        let anzeige = globalsAic(Globals.Einheit, einheit);
        if (anzeige && anzeige.kennung) {
          uiData.prefixAnzeige = anzeige.kennung;
          if (anzeige.kennung === "%") {
            format = "p2";
          }

        }

      } // else if (config.column?.meta.HHmm) {


      //   format = "HH:mm";
      // }
      if (!uiData.number) {
        // soll leer bleiben
        // uiData.number = 0.0;
      }
      if (config.column?.meta.minimum && !isNaN(config.column?.meta.minimum)) {
        uiData.min = config.column.meta.minimum;
      }
      if (config.column?.meta.maximum && !isNaN(config.column?.meta.maximum)) {
        uiData.max = config.column.meta.maximum;
      }

      uiData.format = format ?? "0";
      uiData.decimals = decimals;
      uiData.step = step;
    }
  }
}
export function textChangedEditZahl(txt: any, uiData: NumberControlUIData, config: NumberControlConfig) {
  const value = uiData.number;
  //const prev = txt.previousValue;
  let init = config.initValue;
  if (init && typeof init === "object") {
    init = init.value;
  }
  if (!init) {
    init = 0;
  }
  if (!validateEditZahl(uiData, config)) return;
  valueChanged(config, uiData, uiData.number, false);
  return true;
}
export function validateEditZahl(uiData: NumberControlUIData, config: NumberControlConfig) {
  if (uiData.disabled) {
    uiData.errorText = "";
    return true;
  } // disabled Controls sind IMMER valide ;)
  if (uiData.required) {
    if (uiData.number) {
      uiData.errorText = "";
      return true;
    }
    if (uiData.min || uiData.max) {
      uiData.errorText = "min: " + uiData.min + " max: " + uiData.max;
      return false;
    } else {
      uiData.errorText = config.requiredMessage;
      return false;
    }
  }
  if (uiData.min || uiData.max) {
    uiData.minmaxText = "min: " + uiData.min + " max: " + uiData.max;
    return true;
  }
  if (uiData.number || uiData.number === 0) {
    if (uiData.max && uiData.number > uiData.max) {
      uiData.errorText = begriffBezeichnung("Web_Maximum");
      return false;
    }
    if (uiData.min && uiData.number < uiData.min) {
      uiData.errorText = begriffBezeichnung("Web_Mimimum");
      return false;
    }
  }

  uiData.errorText = "";
  return true;
}